import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Icon, Link } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';
import styles, { stylesheet } from './StickyCTA.module.scss';

const StickyCTA = () => {
    useStyles(stylesheet);

    const { t, i18n } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const heroCTA = document.querySelector('#hero-cta');

        if (!heroCTA) return;

        const handleScroll = () => {
            setIsVisible(heroCTA.getBoundingClientRect().bottom <= 0);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    const logomakerGenAiPath = useMemo(
        () => logomakerCtaPathByLocale(sanitiseLocale(i18n.language)),
        [i18n.language],
    );

    const logomakerCTARef = useTrackNavigationClicked(
        'Design Services',
        'Mobile Sticky CTA',
        logomakerGenAiPath,
        'logoMaker',
    );
    return (
        <Box
            backgroundColor="standard"
            padding={5}
            display={{ xs: 'block', sm: 'none' }}
            className={isVisible ? styles.stickyButton : `${styles.stickyButton} ${styles.hidden}`}
            id="logomaker-genai-sticky-cta"
        >
            <Button
                width="full-width"
                skin="primary"
                iconPosition="left"
                render={(props) => (
                    <Link to={logomakerGenAiPath} className={props.className} ref={logomakerCTARef}>
                        {props.children}
                    </Link>
                )}
            >
                <Icon alt="next step" iconType="magic" />
                {t('Logomaker GenAi Landing Page > Sticky CTA Mobile > Label.value')}
            </Button>
        </Box>
    );
};

export default StickyCTA;
